import React from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import {
  ListGroup,
  ListGroupItem,
} from 'react-bootstrap';

/* eslint-disable react/no-unused-prop-types */
const propTypes = exact({
  allTickets: PropTypes.array.isRequired,
  currentTicketId: PropTypes.number,
  setTicketIdAction: PropTypes.func.isRequired,
  bonusMonth: PropTypes.string,
  districtId: PropTypes.number,
  showProcessed: PropTypes.bool,
});
/* eslint-enable react/no-unused-prop-types */

const TicketList = (props) => {
  const { allTickets, currentTicketId, setTicketIdAction } = props;

  return (
    <div>
      <ListGroup>
        {allTickets.map((item) => {
          const isActive = (item.id === currentTicketId);
          return (
            <ListGroupItem
              className={`list-group-item ${isActive ? 'active' : ''}`}
              key={item.id}
              onClick={() => {
                return setTicketIdAction(item.id);
              }}
            >
              {item.ticket_number.number}, {item.date.display}
            </ListGroupItem>
          );
        })}
      </ListGroup>
    </div>
  );
};

TicketList.propTypes = propTypes;
TicketList.defaultProps = {
  showProcessed: false,
};

export default (TicketList);
